import axios from "axios";
import { UsuarioLogin } from "../types/UsuarioLogin";

const getApiInstance = (token?: string) => {
  const baseURL = window.CONFIG?.REACT_APP_BEMSIGN_AUTENTICACAO_URL;

  if (!baseURL) {
    throw new Error("REACT_APP_BEMSIGN_AUTENTICACAO_URL não está disponível.");
  }

  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem("sessionToken")}`,
    },
  });
};

export const autenticar = async (usuarioLogin: UsuarioLogin) => {
  const api = getApiInstance();
  return await api.post(`/Autenticacao/Autenticar`, {
    usuario: usuarioLogin.usuario,
    senha: usuarioLogin.senha,
  });
};

export const obterUsuario = async (idUsuario: number, token: string) => {
  const api = getApiInstance(token);
  return await api.get(`/Autenticacao/ObterUsuarioPortalPorId/${idUsuario}`);
};

export const obterFotoUsuario = async (usuario: string, token: string) => {
  const api = getApiInstance(token);
  return await api.get(`/Usuario/ObterFotoUsuario/${usuario}`);
};
